import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, Directive, NgModule } from '@angular/core';

const DEFAULT_SIZE = 'auto';
class NxFigureComponent {
    constructor() {
        /** @docs-private */
        this.rounded = false;
        /** @docs-private */
        this.size = DEFAULT_SIZE;
    }
    /**
     * Sets the type of the visual appearance of the image.
     * The default value  is 'auto'.
     */
    set classNames(value) {
        if (this._classNames === value) {
            return;
        }
        this._classNames = value; // TODO properly coerce input value
        // TODO kick null safe-guards after setter value or any calling input values are properly coerced as string
        const sizeRegex = /^(auto|1by1|1dot8by1|1dot2by1|1by1dot1|2dot6by1)$/;
        const [size = null] = this._classNames?.match(sizeRegex) || [DEFAULT_SIZE];
        this.size = size;
        this.rounded = !!this._classNames?.match(/rounded/);
    }
    get classNames() {
        return this._classNames;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: NxFigureComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.2", type: NxFigureComponent, selector: "figure[nxFigure]", inputs: { classNames: ["nxFigure", "classNames"] }, host: { properties: { "class.nx-image": "true", "class.nx-image--auto": "size === \"auto\" && !rounded", "class.nx-image--1by1": "size === \"1by1\"", "class.nx-image--1dot8by1": "size === \"1dot8by1\"", "class.nx-image--1dot2by1": "size === \"1dot2by1\"", "class.nx-image--1by1dot1": "size === \"1by1dot1\"", "class.nx-image--2dot6by1": "size === \"2dot6by1\"", "class.nx-image--rounded": "rounded" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [":host{display:block;position:relative;line-height:0}:host ::ng-deep img{display:block;font-family:\"object-fit: cover;\";object-fit:cover;height:100%;width:100%}:host(.nx-image--auto) ::ng-deep img{height:auto}:host(:not(.nx-image--auto)) ::ng-deep img{position:absolute;top:0;left:0}[dir=rtl] :host(:not(.nx-image--auto)) ::ng-deep img{right:0;left:auto}:host(.nx-image--rounded){padding-top:100%}:host(.nx-image--rounded) ::ng-deep img{border-radius:50%;inset:0;position:absolute}:host(.nx-image--1by1){padding-top:100%}:host(.nx-image--1dot8by1){padding-top:55.5555555556%}:host(.nx-image--1dot2by1){padding-top:83.3333333333%}:host(.nx-image--1by1dot1){padding-top:110%}:host(.nx-image--2dot6by1){padding-top:38.4615384615%}:host(.nx-image--1by1dot4){padding-top:140%}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: NxFigureComponent, decorators: [{
            type: Component,
            args: [{ selector: 'figure[nxFigure]', template: '<ng-content></ng-content>', changeDetection: ChangeDetectionStrategy.OnPush, host: {
                        '[class.nx-image]': 'true',
                        '[class.nx-image--auto]': 'size === "auto" && !rounded',
                        '[class.nx-image--1by1]': 'size === "1by1"',
                        '[class.nx-image--1dot8by1]': 'size === "1dot8by1"',
                        '[class.nx-image--1dot2by1]': 'size === "1dot2by1"',
                        '[class.nx-image--1by1dot1]': 'size === "1by1dot1"',
                        '[class.nx-image--2dot6by1]': 'size === "2dot6by1"',
                        '[class.nx-image--rounded]': 'rounded',
                    }, styles: [":host{display:block;position:relative;line-height:0}:host ::ng-deep img{display:block;font-family:\"object-fit: cover;\";object-fit:cover;height:100%;width:100%}:host(.nx-image--auto) ::ng-deep img{height:auto}:host(:not(.nx-image--auto)) ::ng-deep img{position:absolute;top:0;left:0}[dir=rtl] :host(:not(.nx-image--auto)) ::ng-deep img{right:0;left:auto}:host(.nx-image--rounded){padding-top:100%}:host(.nx-image--rounded) ::ng-deep img{border-radius:50%;inset:0;position:absolute}:host(.nx-image--1by1){padding-top:100%}:host(.nx-image--1dot8by1){padding-top:55.5555555556%}:host(.nx-image--1dot2by1){padding-top:83.3333333333%}:host(.nx-image--1by1dot1){padding-top:110%}:host(.nx-image--2dot6by1){padding-top:38.4615384615%}:host(.nx-image--1by1dot4){padding-top:140%}\n"] }]
        }], propDecorators: { classNames: [{
                type: Input,
                args: ['nxFigure']
            }] } });

class NxImageDirective {
    constructor() {
        console.warn('Directive nxImg which was used together with nxFigure ' +
            'is now deprecated and not required anymore. Please remove it from your ' +
            'tag. Check the documentation for more details.');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: NxImageDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.2", type: NxImageDirective, selector: "img[nxImg]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: NxImageDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'img[nxImg]',
                }]
        }], ctorParameters: () => [] });

class NxImageModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: NxImageModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.2", ngImport: i0, type: NxImageModule, declarations: [NxFigureComponent, NxImageDirective], exports: [NxFigureComponent, NxImageDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: NxImageModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.2", ngImport: i0, type: NxImageModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NxFigureComponent, NxImageDirective],
                    exports: [NxFigureComponent, NxImageDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { NxFigureComponent, NxImageDirective, NxImageModule };
